import { Injectable, inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store, select } from '@ngrx/store';
import type { Observable } from 'rxjs';
import { tap, withLatestFrom } from 'rxjs/operators';
import { RosaAuthStoreActions, RosaAuthStoreSelectors } from '.';
import { RosaCoreLocalStorageKey } from '../../constants/core-local-storage-key.enum';
import type { RosaCoreState } from '../core.state';

@Injectable({
    providedIn: 'root'
})
export class RosaAuthStoreEffects {
    private _action$ = inject(Actions);
    private _store$ = inject<Store<RosaCoreState>>(Store);

    updateOauthTokenEffect$: Observable<any> = createEffect(
        () =>
            this._action$.pipe(
                ofType<RosaAuthStoreActions.UpdateOauthToken>(RosaAuthStoreActions.ActionType.UPDATE_OAUTH_TOKEN),
                withLatestFrom(this._store$.pipe(select(RosaAuthStoreSelectors.selectIsConnectedAs))),
                tap(([action, isConnectedAs]) => {
                    if (!isConnectedAs) {
                        const refreshToken = action.payload.token.refresh_token;
                        if (refreshToken) {
                            localStorage.setItem(RosaCoreLocalStorageKey.REFRESH_TOKEN, refreshToken);
                        }
                        localStorage.setItem(RosaCoreLocalStorageKey.PROJECT_ID, action.payload.token.project_id);
                    } else {
                        localStorage.setItem(RosaCoreLocalStorageKey.CONNECTED_AS_PROJECT_ID, action.payload.token.project_id);
                    }

                    if (action.payload.newSessionId) {
                        sessionStorage.setItem(RosaCoreLocalStorageKey.SESSION_ID, action.payload.newSessionId);
                    }
                })
            ),
        { dispatch: false }
    );
}
